import React from "react";
import {
  List,
  Datagrid,
  TextField,
  DateField,
  EditButton,
  RefreshButton,
  CreateButton
} from "admin-on-rest";
import { CardActions } from "material-ui/Card";
import SupervisorAccount from "material-ui/svg-icons/action/supervisor-account";
import ChartIcon from "material-ui/svg-icons/editor/insert-chart";
import ProductListIcon from "material-ui/svg-icons/action/view-module";
import BroadcastEmailIcon from "material-ui/svg-icons/communication/email";
import { styles } from "./styles";
import "./index.css";
import { Pagination, IconTitle, LinkButton } from "../components";
import IconButton from 'material-ui/IconButton';
import Snackbar from 'material-ui/Snackbar';
import {cyan500} from 'material-ui/styles/colors';
import {RestApi} from '../restClient';
// import IconTitle from "../components/icon_title";
// import Pagination from "../components/pagination";

import { CampaignCreate as create, CampaignEdit as edit } from "./Create";

const CampaignActions = ({ resource, basePath, refresh }) => (
  <CardActions
    style={styles.cardActionStyleSmall}
    className="campaigns-actions"
  >
    <CreateButton basePath={basePath} />
    <RefreshButton basePath={basePath} refresh={refresh} />
  </CardActions>
);
class BroadcastEmailButton extends React.Component{
  constructor(props){
    super(props);
    this.state={
      open:false,
      message:""
    }
    this.handleClose=this.handleClose.bind(this)
  }
  sendEmail(){
    var self=this;
    RestApi("/campaigns/"+this.props.record.id+"/broadcast").then(response=>response.text()).then(function(text){
      self.setState({open:true,message:"Email sent"});
    });
  }
  handleClose(){
    this.setState({open:false});
  }
  render(){
    return (<div>
      <IconButton
        onClick={this.sendEmail.bind(this)}
        iconStyle={{color:cyan500}}
        >
        <BroadcastEmailIcon />
      </IconButton>
      <Snackbar
        open={this.state.open}
        autoHideDuration={3000}
        onRequestClose={this.handleClose}
        message={this.state.message}
      />
    </div>);
  }
}

export const CampaignCreate = create;
export const CampaignEdit = edit;
export const CampaignsList = props => (
  <List
    {...props}
    actions={<CampaignActions />}
    title={<IconTitle icon="accounts" title={"resources.campaigns.title"} />}
    pagination={<Pagination />}
  >
    <Datagrid bodyOptions={{ showRowHover: true }}>
      <TextField label="resources.campaigns.fieldList.name" source="name" />
      <TextField
        label="resources.campaigns.fieldList.status.title"
        source="status"
      />
      <DateField
        label="resources.campaigns.fieldList.start_date"
        source="start_date"
      />
      <DateField
        label="resources.campaigns.fieldList.end_date"
        source="end_date"
      />
      <LinkButton
        {...props}
        icon={<SupervisorAccount />}
        style={{ textAlign: "right", width: 50 }}
        urlPath={"/users"}
      />
      <LinkButton
        {...props}
        icon={<ChartIcon />}
        style={{ textAlign: "right", width: 50 }}
        urlPath={"/chart"}
      />
      <LinkButton
        {...props}
        icon={<ProductListIcon />}
        style={{ textAlign: "right", width: 50 }}
        urlPath={"/products"}
      />
      <BroadcastEmailButton/>
      <EditButton label="" style={{ textAlign: "right", width: 80 }} />
    </Datagrid>
  </List>
);



// WEBPACK FOOTER //
// ./src/campaigns/index.js